import React from "react";
import { Link } from 'react-router-dom';
import blckslogo from '../assets/icons/BLCKS_LOGO_NEW.svg';
import githubicon from '../assets/icons/github.svg';
import linkedinicon from '../assets/icons/linkedin.svg';
import xicon from '../assets/icons/x.svg';
import maildark from '../assets/contact/mail_dark.svg';

const FooterMobile = () => {
  const productLinks = [
    "Consulting",
    "Sales Block",
    "Office Block",
    "Insight Block",
    "Service Block"
  ];

  const companyLinks = [
    { text: "Über uns", link: "/about" },
    { text: "Presse & News", link: "#" },
    { text: "Preise", link: "/pricing" },
    { text: "Karriere", link: "#" },
    { text: "Kontakt", link: "/contact" }
  ];

  const resourceLinks = [
    { text: "FAQ", link: "/faq" },
    { text: "Blog", link: "/blog" },
    { text: "KI-News", link: "#" },
    { text: "Tools & Links", link: "#" },
    { text: "Fallstudien", link: "#" },
    { text: "KI Förderungen", link: "#" },
    { text: "KI Online Audit", link: "https://audit.blcks.at" }
  ];

  const bottomLinks = [
    { text: "Impressum", link: "/impressum" },
    { text: "Datenschutzrichtlinie", link: "/datenschutz" },
    { text: "Cookie-Richtlinie", link: "/cookie-richtlinie" },
    {
      text: "Cookie Einstellungen",
      link: "#",
      onClick: (e) => {
        e.preventDefault();
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event('showCookieConsentDialog'));
        }
      }
    },
    { text: "AGB", link: "/agb" }
  ];

  return (
    <footer className="relative overflow-hidden pt-10 px-4 pb-12 bg-[#010003]">
      <div className="max-w-[1408px] mx-auto relative z-10">
        {/* Logo and Social */}
        <div className="flex flex-col items-center mb-8">
          <Link to="/" className="block w-fit mb-6">
            <img src={blckslogo} alt="BLCKS Logo" className="h-8 w-auto" />
          </Link>
          {/* Social Media Icons */}
          <div className="flex gap-x-7">
            <a href="https://www.linkedin.com/in/philippfuchs-blcks" target="_blank" rel="noopener noreferrer">
              <img src={linkedinicon} alt="LinkedIn" className="w-6 h-6" />
            </a>
            {/*<a href="https://x.com/blcksai" target="_blank" rel="noopener noreferrer">
              <img src={xicon} alt="X" className="w-6 h-6" />
            </a>*/}
            {/*<a href="https://github.com/blcksdev" target="_blank" rel="noopener noreferrer">
              <img src={githubicon} alt="GitHub" className="w-6 h-6" />
            </a>*/}
          </div>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-col gap-8">
          {/* Lösungen and Unternehmen side by side */}
          <div className="flex gap-8">
            {/* Product Links */}
            <div className="w-1/2">
              <h3 className="font-['Geist',Helvetica] font-medium text-white text-[15px] tracking-[-0.32px] leading-[19.5px] mb-5">
                Lösungen
              </h3>
              <div className="flex flex-col" style={{ gap: '1rem' }}>
                {productLinks.map((link, index) => (
                  <Link
                    key={`product-${index}`}
                    to="#"
                    className="font-['Geist',Helvetica] font-light text-[#adb0b9] text-[15px] tracking-[-0.32px] leading-[15px] hover:text-white transition-colors"
                  >
                    {link}
                  </Link>
                ))}
              </div>
            </div>
            {/* Company Links */}
            <div className="w-1/2">
              <h3 className="font-['Geist',Helvetica] font-medium text-white text-[15px] tracking-[-0.32px] leading-[19.5px] mb-5">
                Unternehmen
              </h3>
              <div className="flex flex-col" style={{ gap: '1rem' }}>
                {companyLinks.map((link, index) => (
                  <Link
                    key={`company-${index}`}
                    to={link.link}
                    className="font-['Geist',Helvetica] font-light text-[#adb0b9] text-[15px] tracking-[-0.32px] leading-[15px] hover:text-white transition-colors"
                  >
                    {link.text}
                  </Link>
                ))}
              </div>
            </div>
          </div>
          {/* Resource Links */}
          <div className="w-full">
            <h3 className="font-['Geist',Helvetica] font-medium text-white text-[15px] tracking-[-0.32px] leading-[19.5px] mb-5">
              Ressourcen
            </h3>
            <div className="flex flex-col" style={{ gap: '1rem' }}>
              {resourceLinks.map((link, index) => (
                <Link
                  key={`resource-${index}`}
                  to={link.link}
                  className="font-['Geist',Helvetica] font-light text-[#adb0b9] text-[15px] tracking-[-0.32px] leading-[15px] hover:text-white transition-colors"
                >
                  {link.text}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Email Button - Left aligned */}
        <div className="flex justify-start">
          <a
            href="mailto:hello@blcks.at"
            className="transition-shadow duration-300 group inline-flex items-center relative justify-center rounded-full tracking-tight h-10 text-16 px-5 bg-white text-[#0d0e12] font-medium w-fit shadow-[0px_6px_16px_rgba(255,255,255,.2)] hover:shadow-[0px_6px_56px_0px_rgba(255,255,255,.4),0px_4px_15px_0px_rgba(0,0,0,.2)]"
          >
            <span
              className="pointer-events-none absolute inset-0 z-0 rounded-[inherit] bg-gradient-to-r from-white to-gray-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
              aria-hidden="true"
            />
            <img
              src={maildark}
              alt=""
              className="relative z-10 h-5 w-5 mr-3"
              width={18}
              height={18}
            />
            <span className="relative z-10 text-[#0d0e12] font-geist font-normal">hello@blcks.at</span>
          </a>
        </div>
      </div>

      {/* Bottom section - Left aligned with responsive layout */}
      <div className="w-full max-w-[1344px] mx-auto mt-10 pt-10">
        <div className="flex flex-col">
          <div className="font-['Geist'] font-light text-[#787c87] text-[14px] tracking-[-0.02em] leading-[18.2px] mb-4">
            &copy; {new Date().getFullYear()} blcks, Designed and Built by{' '}
            <a
              href="https://blcks.at/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#787c87] hover:text-white transition-colors"
            >
              blcks
            </a>
          </div>

          {/* Bottom links - Responsive layout: side-by-side when space allows, with line breaks */}
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {bottomLinks.map((link, index) => (
              link.onClick ? (
                <a
                  key={`bottom-${index}`}
                  href="#"
                  onClick={link.onClick}
                  className="font-['Geist'] font-light text-[#787c87] text-[14px] tracking-[-0.02em] leading-[18.2px] hover:text-white transition-colors"
                >
                  {link.text}
                </a>
              ) : (
                <Link
                  key={`bottom-${index}`}
                  to={link.link}
                  className="font-['Geist'] font-light text-[#787c87] text-[14px] tracking-[-0.02em] leading-[18.2px] hover:text-white transition-colors"
                >
                  {link.text}
                </Link>
              )
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterMobile;